import axios from 'axios'
import { _getEatereyUserTimes, _getBindUsers } from './entrySummary'
import { _getImageRegions } from './imageClip'
import { _password_update, _pwd_check_update, _login } from './loginApi'
import {
  _uploadExcel,
  _menuBatchAdd,
  _uploadExcelNutrition,
  _setPermanent,
  _getMenuByDate,
  _deleteMenus,
  _queryCalorieByFoodName,
  _queryCalorieByFoodNameCalorieMode,
  _menuBatchUpdate,
  _menuAdd,
  _menuDelete,
  _menuImgQueryByfoodUuidList,
  _foodQueryByName,
  _menuUpdate
} from './menuApi'
import {
  _saleRecordQuery,
  _getSummarySheet,
  _salerecordGenerateSheet,
  _salerecordDetailQuery,
  _salerecordAdd
} from './recordApi'
import { _apiOutLogin, _getFaceUsers, _addFaceUsers, _getFaceUserDetail, _editFaceUser, _deleteFaceUser } from './faceAdminApi'
import { _getCanteenList, _getMachineList } from './canteenApi'

// import state from ''
import store from '@/store'
let baseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://enterprise.zhihuituancan.com'
  if (process.env.VUE_APP_SERVER_TYPE === 'dev') {
    baseUrl = 'http://127.0.0.1:7705'
  }
} else {
  baseUrl = 'https://testmanagement.zhihuituancan.com'
  if (process.env.VUE_APP_SERVER_TYPE === 'pro') {
    baseUrl = 'https://enterprise.zhihuituancan.com'
  }
}

// let baseUrl = process.env.BASE_URL
export const httpFaceClient = axios.create({
  baseURL: baseUrl + '/api/face/v0.1',
  timeout: 60000,
  headers: {
    Accept:
      'text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8,application/x-www-form-urlencoded'
  }
})
export const httpQueryCarlorie = axios.create({
  baseURL: 'https://enterprise.zhihuituancan.com',
  timeout: 60000,
  headers: {
    Accept:
      'text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8,application/x-www-form-urlencoded'
  }
})

export const httpClient = axios.create({
  baseURL: baseUrl + '/apiv1',
  timeout: 60000,
  headers: {
    Accept:
      'text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8,application/x-www-form-urlencoded'
  }
})
export const httpClientMock = axios.create({
  baseURL: 'https://easy-mock.com/mock/5cb45922136f8104033407b1',
  timeout: 60000,
  headers: {
    Accept:
      'text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8,application/x-www-form-urlencoded'
  }
})
export const httpClient1 = axios.create({
  baseURL: 'https://enterprise.zhihuituancan.com/',
  timeout: 60000,
  headers: {
    Accept:
      'text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8,application/x-www-form-urlencoded'
  }
})
httpClient.interceptors.request.use(
  config => {
    const api_key = store.getters.userinfo().api_key
    if (config.url !== 'login/' && config.url !== 'out-api/login') {
      config.headers['api-key'] = api_key
    }
    console.log('----请求url: ' + config.url)
    console.log('----请求数据: ' + config.data)
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
httpFaceClient.interceptors.request.use(
  config => {
    console.log('----请求url: ' + config.url)
    console.log('----请求数据: ' + config.data)
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
httpClient.interceptors.response.use(
  res => {
    console.log('++++++返回数据', res)
    return res
  },
  err => Promise.reject(err)
)

export const handleError = err => {
  console.log(err)
  if (err.response) {
    console.log(err.response.status)
    console.log(err.response.headers)
  } else if (err.request) {
    console.log(err.request)
  } else {
    console.log('Error', err.message)
  }
}
export const apiGetEateryUserTimes = _getEatereyUserTimes
export const apiGetBindUsers = _getBindUsers
export const apiGetImageRegions = _getImageRegions
export const apiPasswordUpdate = _password_update
export const apiPwdCheckUpdate = _pwd_check_update
export const apiUploadExcel = _uploadExcel
export const apiMenuBatchAdd = _menuBatchAdd
export const apiSetPermanent = _setPermanent
export const apiUploadExcelNutrition = _uploadExcelNutrition
export const apiSaleRecordQuery = _saleRecordQuery
export const apiGetSummarySheet = _getSummarySheet
export const apiLogin = _login
export const apiGetCanteenList = _getCanteenList
export const apiGetMenuByDate = _getMenuByDate
export const apiDeleteMenus = _deleteMenus
export const apiQueryCalorieByFoodName = _queryCalorieByFoodName
export const apiQueryCalorieByFoodNameCalorieMode = _queryCalorieByFoodNameCalorieMode
export const apiMenuBatchUpdate = _menuBatchUpdate
export const apiMenuAdd = _menuAdd
export const apiMenuDelete = _menuDelete
export const apiGetMachineList = _getMachineList
export const apiSalerecordGenerateSheet = _salerecordGenerateSheet
export const apiSalerecordDetailQuery = _salerecordDetailQuery
export const apiSalerecordAdd = _salerecordAdd
export const apiMenuImgQueryByfoodUuidList = _menuImgQueryByfoodUuidList
export const apiFoodQueryByName = _foodQueryByName
export const apiMenuUpdate = _menuUpdate
export const apiFaceLogin = _apiOutLogin
export const apiGetFaceUsers = _getFaceUsers
export const apiaddFaceUsers = _addFaceUsers
export const apiEditFaceUser = _editFaceUser
export const apiDeleteFaceUser = _deleteFaceUser
export const apiGetFaceUserDetail = _getFaceUserDetail
